import React from "react"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import DeductionsTable from "./DeductionsTable"
import { useTranslation } from "react-i18next"

export default function DeductionsList() {

  const { t } = useTranslation()
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Payslip Item")} />
        <DeductionsTable />
      </div>
    </div>
  )
}
